import { call, put, takeEvery } from "redux-saga/effects";
import {
  userForgetPasswordError,
  userForgetPasswordSuccess,
  userResetPasswordSuccess,
  userResetPasswordError,
  EmailVerifySuccess,
  EmailVerifyError,
  resetUserSuccesss,
  resetUserFails,
  changepwdSuccess,
  changepwdFails,
} from "./actions";
// Login Redux States
import toast from "toastr";
import {
  FORGET_PASSWORD,
  POST_RESET_USER,
  POST_CHANGE_PASSWORD,
  RESET_PASSWORD,
  VERIFY_EMAIL_ACCOUNT,
} from "./actionTypes";
import { togglePageLoader } from "../../actions";
import {
  getForgotPassword,
  getResetPassword,
  postChangePassword,
} from "../../../helpers/api";
import { notifications } from "@mantine/notifications";

function* forgetUser({ payload: { user } }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(getForgotPassword, user);
    yield put(togglePageLoader(false));
    if (response?.statusCode === 200) {
      yield put(userForgetPasswordSuccess(response));
      if (response?.username) {
        toast.success(response.message);
      } else {
        yield put(userForgetPasswordError(response));
        toast.error(response.statusMessage);
      }
    }else {
      yield put(userForgetPasswordError(response));
      toast.error(response?.statusMessage);
    }  
  } catch (error) {
    yield put(togglePageLoader(false));
  }
}

function* resetPasswordAction({ payload: { user, navigate } }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(getResetPassword, user); 
    if (response.message === "Password Reset successfully.") {    
      yield put(userResetPasswordSuccess(response));
      toast.success(response.message);
      yield put(togglePageLoader(false));
      if (navigate) {
        navigate('/'); 
      } else {
        console.error('Navigate function is undefined!');
      }
    } else {
      yield put(userResetPasswordError(response));
      toast.error(response.message);
      yield put(togglePageLoader(false));
    }
    
  } catch (error) {
    yield put(userResetPasswordError(false));

  }
}

// function* verifyEmailAccount({ payload: { data } }) {
//   try {
//     yield put(togglePageLoader(true));
//     const response = yield call(verifyEmailAccountApi, data);
//     yield put(togglePageLoader(false));
//     console.log(response, "response");
//     if (response.status === "Success") {
//       console.log("enter");
//       yield put(EmailVerifySuccess(response));
//     }
//     if (response.status === "Failed") {
//       yield put(EmailVerifyError(response));
//     }
//   } catch (error) {
//     yield put(togglePageLoader(false));
//   }
// }
// function* onResetUser({ payload: { user, history } }) {
//   try {
//     const response = yield call(compresetPasswordApi, user);
//     console.log(response, "data");
//     if (response.status === "Success") {
//       yield put(resetUserSuccesss({ response }));
//       history.push("/login");
//     }
//     if (response.status === "Failure") {
//       yield put(resetUserFails(response));
//     }
//     if (response.status === "Failed") {
//       yield put(resetUserFails(response));
//     }
//   } catch (error) {
//     yield put(resetUserFails(error));
//   }
// }
//change password in profile page for saga
function* onChangePwd({ payload: data, callback }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(postChangePassword, data);
    if (response) {
      yield put(changepwdSuccess({ response }));
      toast.success(response.message);
      yield put(togglePageLoader(false));
      callback("SUCCESS");
    } else {
      yield put(changepwdFails(response));
      toast.success(response.message);
      yield put(togglePageLoader(false));
      callback("Fail");
    }
   
  }
   catch (error) {
    yield put(changepwdFails(error));
  }
}

function* forgetPasswordSaga() {
  yield takeEvery(FORGET_PASSWORD, forgetUser);
  yield takeEvery(RESET_PASSWORD, resetPasswordAction);
  //yield takeEvery(VERIFY_EMAIL_ACCOUNT, verifyEmailAccount);
  // reset password
  //yield takeEvery(POST_RESET_USER, onResetUser);
  yield takeEvery(POST_CHANGE_PASSWORD, onChangePwd);
}

// resetPasswordApi
export default forgetPasswordSaga;
